import { getSelectedProduct } from '@vend/business-components'
import { VdFeatureManager } from '@vend/vend.js'
import type { ModalFactory, ModalObject } from '../../../vend-ui/types'

import { $q } from '../../../ng-compat/imports'
import { WebRegisterStatusManager } from '../../../managers/web-register-status-manager'
import { TrainingModeManager } from '../../../managers/training-mode-manager'
import { UserManager } from '../../../managers/user-manager'
import { RegisterManager } from '../../../managers/register-manager'
import { PERMISSIONS } from '../../../constants'
import variantPickerModalTemplate from './variant-picker-modal.html'

/**
 * Service class for variant picker modal.
 *
 * @class VariantPickerModalService
 */
export class VariantPickerModalService {
  constructor(
    private readonly Modal: ModalFactory,
    private vdFeatureManager: VdFeatureManager,
    private webRegisterStatusManager: WebRegisterStatusManager,
    private trainingModeManager: TrainingModeManager,
    private userManager: UserManager,
    private registerManager: RegisterManager,
    private $location: $TSFixMe
  ) {
    'ngInject'
  }

  /**
   * Open the variant picker modal.
   *
   * @method openVariantPicker
   *
   * @return {ModalInstance} The instance of the modal.
   */
  public openVariantPicker(options: any) {
    const isOverMaxVariantsLimit =
      !this.vdFeatureManager.get('increase_variant_limit') &&
      options.variantProducts.length >= 200

    const showAddValue =
      this.webRegisterStatusManager.isOnline() &&
      !this.trainingModeManager.trainingModeEnabled &&
      this.userManager.hasPermission(PERMISSIONS.PRODUCT_ADD_EDIT) &&
      this.registerManager.isActiveRegisterOpen() &&
      !isOverMaxVariantsLimit &&
      !this.$location.path().includes('/settings/quickkeys/')

    return this.Modal({
      controller: 'variantPickerModalController',
      controllerAs: '$ctrl',
      template: variantPickerModalTemplate,
      title: options.title,
      parentProduct: options.parentProduct,
      variantProducts: options.variantProducts,
      allowVariantParentSelect: options.allowVariantParentSelect,
      showAddValue,
      initialVariantAttributeConfig: options.initialVariantAttributeConfig,
    })
      .then((modal: ModalObject) => modal.closed)
      .then((product: any) => {
        if (!product) {
          return $q.reject()
        }

        return getSelectedProduct(product)
      })
      .catch(() => {}) // Empty catch here to avoid raygun unhandled rejection error when press Esc to close the modal
  }
}
